import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "stars", "form", "currentRating"];

  connect() {
    if (this.hasInputTarget) {
      this.updateStars(this.inputTarget.value);
    }
  }

  setValue(event) {
    let rating = parseInt(event.currentTarget.dataset.value);

    // If user clicks the same star that's already selected, clear the rating
    if (rating.toString() === this.inputTarget.value) {
      rating = 0;
    }

    this.inputTarget.value = rating;
    this.updateStars(rating);

    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    }
  }

  updateStars(rating) {
    if (this.hasStarsTarget) {
      const stars = this.starsTarget.querySelectorAll(".star-icon");

      stars.forEach((star, index) => {
        const starValue = parseInt(star.dataset.value);

        if (starValue <= rating) {
          star.classList.add("has-text-warning");
          star.classList.remove("has-text-grey-lighter");
          star.querySelector("i").className = "fas fa-star";
        } else {
          star.classList.remove("has-text-warning");
          star.classList.add("has-text-grey-lighter");
          star.querySelector("i").className = "far fa-star";
        }
      });
    }

    if (this.hasCurrentRatingTarget) {
      this.currentRatingTarget.textContent = rating;
    }
  }

  hover(event) {
    const rating = parseInt(event.currentTarget.dataset.value);
    this.updateStars(rating);
  }

  resetHover() {
    this.updateStars(this.inputTarget.value);
  }
}
